import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { Card } from '@klopotun/contracts';
import { cardQueries } from '../queries/card-queries.js';
import { archiveCard } from '../requests/archive-card.js';
import { restoreCard } from '../requests/restore-card.js';

export type CardArchiveInput = { action: 'archive' | 'restore'; id: string };

const changeCardArchive = (input: CardArchiveInput): Promise<Card> => {
  if (input.action === 'archive') {
    return archiveCard(input.id);
  }
  return restoreCard(input.id);
};

/**
 * The default listing asks for unarchived cards only, so dropping the whole list branch is what
 * takes an archived card out of every picker on screen.
 */
export const useCardArchiveMutation = (): UseMutationResult<Card, Error, CardArchiveInput> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: changeCardArchive,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: cardQueries.lists() }),
  });
};
